'use client';

import { useRouter } from 'next/navigation';
import SearchInputBasic from '@/components/common/SearchInputBasic';
import { getSourcePath } from '@/rewrites';
import { searchGlossaryTerm } from '@/actions/directus';

const GlossarySearchBar = () => {
  const router = useRouter();

  const handleGlossarySearch = async (query: string) => {
    return await searchGlossaryTerm(query.trim());
  };

  const handleGlossaryResultClick = (slug: string) => {
    router.push(`${getSourcePath('/glossary')}/${slug}`);
  };

  return (
    <SearchInputBasic
      onSearch={handleGlossarySearch}
      onResultClick={handleGlossaryResultClick}
      placeholder="Begriff suchen …"
    />
  );
};

export default GlossarySearchBar;
